











































































































































































































































import { format, parseISO } from "date-fns";
import VueI18n from "vue-i18n";
import { Component, Vue, Watch } from "vue-property-decorator";
import { DataOptions, DataTableHeader } from "vuetify";
import {
  TreatmentDatabasesApi,
  TreatmentDatabasesApiGetTreatmentDatatbasesSearchRequest,
  TreatmentMasterListsApi,
  TreatmentRequestsApi,
  TreatmentRequestsApiGetTreatmentRequestsByKeywordRequest,
  TreatmentRequestsApiExportTreatmentRequestsByKeywordRequest,
} from "../../../apis";
import ConfirmDialog from "../../components/user-management/ConfirmDialog.vue";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import moment from "moment";
import { VueExcelEco2 } from "../common/VueExcelEco2";
import ContinueTreatmentDialog from "./ContinueTreatmentDialog.vue";
import StopTreatmentDialog from "./StopTreatmentDialog.vue";
import isEmpty from "lodash/isEmpty";
// import FinishTreatmentDialog from "./FinishTreatmentDialog.vue";

export enum ACTION {
  START = "START",
  VIEW = "VIEW",
  GRAPH = "GRAPH",
  VIEWCERTIFICATE = "VIEWCERTIFICATE",
  EDIT = "EDIT",
  DELETE = "DELETE",
  CONTINUE = "CONTINUE",
  STOP = "STOP",
  // FINISH = "FINISH",
}

@Component({
  components: {
    // FinishTreatmentDialog,
    MoreVertBtn,
    ConfirmDialog,
    ContinueTreatmentDialog,
    StopTreatmentDialog,
  },
})
export default class TreatmentRequestList extends Vue {
  items: any[] = [];
  pagingOption: DataOptions | null = null;
  searchParam: any = {
    status: "",
    technique: 0,
  };
  totalRecord: number = 0;
  pageBeforeSort: number = 0;

  techniqueOptions = [];

  statusOptions = [
    { value: "", name: this.$t("text.all") },
    { value: "In Request", name: this.$t("text.inRequest") },
    { value: "In Progress", name: this.$t("text.inProgress") },
    { value: "Finished", name: this.$t("text.finished") },
    { value: "Cancelled", name: this.$t("text.cancelled") },
  ];

  formatTimeOptions = [
    { value: "MINUTES", text: this.$t("text.MINUTES") },
    { value: "HOURS", text: this.$t("text.HOURS") },
    { value: "DAYS", text: this.$t("text.DAYS") },
    { value: "WEEKS", text: this.$t("text.WEEKS") },
    { value: "MONTHS", text: this.$t("text.MONTHS") },
  ];

  treatmentTypeOptions = [
    { value: "Normal", text: this.$t("text.Normal") },
    { value: "Special", text: this.$t("text.Special") },
  ];

  packageOptions = [];
  setPointOptions = [];
  isShowContinueTreatmentDialog = false;
  isShowStopTreatmentDialog = false;
  // isShowFinishTreatmentDialog = false;

  columnsExport = [
    {
      label: this.$t("text.status"),
      field: "status",
    },
    {
      label: this.$t("text.customer"),
      field: "customerName",
    },
    {
      label: this.$t("text.location"),
      field: "locationName",
    },
    {
      label: this.$t("text.no"),
      field: "number",
    },
    {
      label: this.$t("text.unit"),
      field: "unitName",
    },
    {
      label: this.$t("text.treatmentType"),
      field: "treatmentType",
    },
    // {
    //   label: this.$t("text.specialRequest"),
    //   field: "specialRequest",
    // },
    {
      label: this.$t("text.technique"),
      field: "techniqueName",
    },
    {
      label: this.$t("text.product"),
      field: "productName",
    },
    {
      label: this.$t("text.insect"),
      field: "insects",
    },
    {
      label: 'Weight(KG)',
      field: "totalWeight",
    },
    {
      label: 'Pallet(PCS)',
      field: "numberOfPallets",
    },
    {
      label: this.$t("text.lotBatchNumbers"),
      field: "lotNumber",
    },
    {
      label: this.$t("text.packing"),
      field: "package.treatmentName",
    },
    {
      label: this.$t("text.numberOfPackages"),
      field: "numberOfPackages",
    },
    {
      label: this.$t("text.treatmentTime"),
      field: "treatmentTime",
    },
    {
      label: this.$t("text.setpoint"),
      field: "condition",
    },
    {
      label: this.$t("text.startTemperature"),
      field: "startTemperature",
    },
    {
      label: this.$t("text.startDate"),
      field: "startDate",
    },
    {
      label: this.$t("text.reachingO2Level"),
      field: "reachingO2Level",
    },
    {
      label: this.$t("text.reachingProductTemp"),
      field: "reachingProductTemp",
    },
    {
      label: this.$t("text.expectedEndDate"),
      field: "expectedEndDate",
    },
    {
      label: this.$t("text.endDate"),
      field: "endDate",
    },
    {
      label: this.$t("text.durationTreatment"),
      field: "durationTreatment",
    },
    {
      label: this.$t("text.durationTemperature"),
      field: "durationTemperature",
    },
    {
      label: this.$t("text.durationReachO2"),
      field: "durationReachO2",
    },
    {
      label: this.$t("text.remark"),
      field: "remark",
    },
    {
      label: `${this.$t("text.setpoint")} 1 ${this.$t("text.setpointName")}`,
      field: "setPointName1",
    },
    {
      label: `${this.$t("text.setpoint")} 1 ${this.$t("text.value")}`,
      field: "setPointValue1",
    },
    {
      label: `${this.$t("text.setpoint")} 2 ${this.$t("text.setpointName")}`,
      field: "setPointName2",
    },
    {
      label: `${this.$t("text.setpoint")} 2 ${this.$t("text.value")}`,
      field: "setPointValue2",
    },
    {
      label: `${this.$t("text.setpoint")} 3 ${this.$t("text.setpointName")}`,
      field: "setPointName3",
    },
    {
      label: `${this.$t("text.setpoint")} 3 ${this.$t("text.value")}`,
      field: "setPointValue3",
    },
    {
      label: `${this.$t("text.setpoint")} 4 ${this.$t("text.setpointName")}`,
      field: "setPointName4",
    },
    {
      label: `${this.$t("text.setpoint")} 4 ${this.$t("text.value")}`,
      field: "setPointValue4",
    },
  ];

  dataExport = [];

  readonly START_ACTION: IAction = {
    titleName: this.$t("text.start"),
    action: ACTION.START,
    titleStyle: "color: #43D79E",
    permission: {
      context: "TREATMENT_MANAGEMENT|START_STOP_CONTINUE",
      action: "update",
    },
  };

  readonly VIEW_ACTION: IAction = {
    titleName: this.$t("text.view"),
    action: ACTION.VIEW,
  };

  readonly VIEW_GRAPH_ACTION: IAction = {
    titleName: this.$t("text.treatmentGraph"),
    action: ACTION.GRAPH,
  };

  readonly VIEWCERTIFICATE_ACTION: IAction = {
    titleName: this.$t("text.viewCertificate"),
    action: ACTION.VIEWCERTIFICATE,
    permission: {
      context: "TREATMENT_MANAGEMENT|VIEW_CERTIFICATE",
      action: "read",
    },
  };

  readonly EDIT_ACTION: IAction = {
    titleName: this.$t("text.edit"),
    action: ACTION.EDIT,
    permission: { context: "TREATMENT_MANAGEMENT", action: "update" },
  };

  readonly CONTINUE_ACTION: IAction = {
    titleName: this.$t("text.continue"),
    action: ACTION.CONTINUE,
    titleStyle: "color: #43D79E",
    permission: {
      context: "TREATMENT_MANAGEMENT|START_STOP_CONTINUE",
      action: "update",
    },
  };

  readonly DELETE_ACTION: IAction = {
    titleName: this.$t("text.delete"),
    action: ACTION.DELETE,
    titleStyle: "color: #E54949",
    permission: { context: "TREATMENT_MANAGEMENT", action: "delete" },
  };

  readonly STOP_ACTION: IAction = {
    titleName: this.$t("text.stop"),
    action: ACTION.STOP,
    titleStyle: "color: #E54949",
    permission: {
      context: "TREATMENT_MANAGEMENT|START_STOP_CONTINUE",
      action: "update",
    },
  };

  // readonly FINISH_ACTION: IAction = {
  //   titleName: this.$t("text.finish"),
  //   action: ACTION.EDIT,
  //   permission: { context: "TREATMENT_MANAGEMENT", action: "update" },
  // };

  BASE_HEADER = [
    {
      text: this.$t("text.status"),
      value: "status",
      class: ["column-sticky", "tw-whitespace-no-wrap", "tw-left-0"],
      cellClass: ["column-sticky", "tw-whitespace-no-wrap", "tw-left-0"],
    },
    {
      text: this.$t("text.customer"),
      value: "customerName",
      class: ["column-sticky", "tw-whitespace-no-wrap"],
      cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
    },
    {
      text: this.$t("text.location"),
      value: "locationName",
      class: ["column-sticky", "tw-whitespace-no-wrap"],
      cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
    },
    {
      text: this.$t("text.no"),
      value: "number",
      class: ["column-sticky", "tw-whitespace-no-wrap"],
      cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
    },
    {
      text: this.$t("text.unit"),
      value: "unitName",
      class: ["column-sticky", "tw-whitespace-no-wrap"],
      cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
    },
    {
      text: this.$t("text.treatmentType"),
      value: "treatmentType",
      class: ["tw-whitespace-no-wrap"],
      cellClass: ["tw-whitespace-no-wrap"],
    },
    // {
    //   text: this.$t("text.specialRequest"),
    //   value: "specialRequest",
    //   class: ["tw-whitespace-no-wrap"],
    //   cellClass: ["tw-whitespace-no-wrap"],
    // },
    {
      text: this.$t("text.technique"),
      value: "techniqueName",
      class: ["tw-whitespace-no-wrap"],
      cellClass: ["tw-whitespace-no-wrap"],
    },
    {
      text: this.$t("text.product"),
      value: "productName",
      class: ["tw-p-4"]
    },
    {
      text: this.$t("text.insect"),
      value: "insects",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: 'Weight(KG)',
      value: "totalWeight",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: 'Pallet(PCS)',
      value: "numberOfPallets",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: this.$t("text.lotBatchNumbers"),
      value: "lotNumber",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: this.$t("text.packing"),
      value: "package.treatmentName",
      class: ["tw-p-4"]
    },
    {
      text: this.$t("text.numberOfPackages"),
      value: "numberOfPackages",
      class: ["tw-p-4"]
    },
    {
      text: this.$t("text.treatmentTime"),
      value: "treatmentTime",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: this.$t("text.setpoint"),
      value: "condition",
      class: ["tw-p-4"]
    },
    {
      text: this.$t("text.startTemperature"),
      value: "startTemperature",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: this.$t("text.startDate"),
      value: "startDate",
      class: ["tw-whitespace-no-wrap"],
      cellClass: ["tw-whitespace-no-wrap"]
    },
    {
      text: this.$t("text.reachingO2Level"),
      value: "reachingO2Level",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: this.$t("text.reachingProductTemp"),
      value: "reachingProductTemp",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: this.$t("text.expectedEndDate"),
      value: "expectedEndDate",
      class: ["tw-whitespace-no-wrap"],
      cellClass: ["tw-whitespace-no-wrap"],
    },
    {
      text: this.$t("text.endDate"),
      value: "endDate",
      class: ["tw-whitespace-no-wrap"],
      cellClass: ["tw-whitespace-no-wrap"]
    },
    {
      text: this.$t("text.durationTreatment"),
      value: "durationTreatment",
      sortable: false,
      class: ["tw-whitespace-no-wrap"],
      cellClass: ["tw-whitespace-no-wrap"]
    },
    {
      text: this.$t("text.durationTemperature"),
      value: "durationTemperature",
      sortable: false,
      class: ["tw-whitespace-no-wrap"],
      cellClass: ["tw-whitespace-no-wrap"]
    },
    {
      text: this.$t("text.durationReachO2"),
      value: "durationReachO2",
      sortable: false,
      class: ["tw-whitespace-no-wrap"],
      cellClass: ["tw-whitespace-no-wrap"]
    },
    {
      text: this.$t("text.shipmentCertificates"),
      value: "hasShipmentCertificate",
      sortable: false,
      class: ["tw-whitespace-no-wrap"],
      cellClass: ["tw-whitespace-no-wrap"],
    },
    {
      text: this.$t("text.remark"),
      value: "remark",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: `${this.$t("text.setpoint")} 1 ${this.$t("text.setpointName")}`,
      value: "setPointName1",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: `${this.$t("text.setpoint")} 1 ${this.$t("text.value")}`,
      value: "setPointValue1",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: `${this.$t("text.setpoint")} 2 ${this.$t("text.setpointName")}`,
      value: "setPointName2",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: `${this.$t("text.setpoint")} 2 ${this.$t("text.value")}`,
      value: "setPointValue2",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: `${this.$t("text.setpoint")} 3 ${this.$t("text.setpointName")}`,
      value: "setPointName3",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: `${this.$t("text.setpoint")} 3 ${this.$t("text.value")}`,
      value: "setPointValue3",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: `${this.$t("text.setpoint")} 4 ${this.$t("text.setpointName")}`,
      value: "setPointName4",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: `${this.$t("text.setpoint")} 4 ${this.$t("text.value")}`,
      value: "setPointValue4",
      sortable: false,
      class: ["tw-p-4"]
    },
    {
      text: this.$t("text.action"),
      value: "action",
      sortable: false,
      class: ["tw-p-4"],
    },
  ] as DataTableHeader[];

  headers = this.BASE_HEADER as DataTableHeader[];

  confirmContent: string | VueI18n.TranslateResult = "";
  showConfirmDialog = false;

  createdFromDate = new Date().toISOString().substr(0, 10);
  createdToDate = new Date().toISOString().substr(0, 10);

  loading = false;
  intervalId = null;

  clearInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  beforeDestroy() {
    this.clearInterval();
  }

  async mounted() {
    this.searchParam.status = this.$route.query.status;
    await this.handleGetMasterList();
    this.doSearch();
    this.intervalId = setInterval(() => {
      if (!this.loading) this.doSearch(false);
    }, 1000 * 60);
  }

  updated() {
    this.frozenColumnsBuilder();
  }

  frozenColumnsBuilder() {
    const tableThs: any = document.querySelectorAll(
      ".treatment-request-table table thead tr th"
    );
    this.$nextTick(() => {
      const leftPxArr = [];
      for (let idx = 0; idx <= 3; idx++) {
        const headTh: any = document.querySelector(
          `table > thead > tr > th:nth-child(${idx + 2})`
        );
        const bodyTds: any = (numb) =>
          document.querySelectorAll(
            `table > tbody > tr > td:nth-child(${numb})`
          );
        leftPxArr.push(tableThs[idx].getBoundingClientRect().width);
        const leftPx = leftPxArr.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          0
        );
        if (headTh) {
          headTh.style.left = leftPx + "px";
        }
        const bodyTs2 = bodyTds(idx + 2);
        if (bodyTs2) {
          bodyTs2.forEach((td) => {
            td.style.left = leftPx + "px";
          });
        }
      }
    });
  }

  get navbarShow() {
    return this.$store.getters.navbarShow;
  }

  @Watch("navbarShow")
  onWatchNavbarShow() {
    setTimeout(() => {
      this.frozenColumnsBuilder();
    }, 500);
  }

  async onSearch() {
    await this.doSearch();
  }

  onPagingOption() {
    this.onSearch();
  }

  getColor(status): string {
    switch (status) {
      case "In Request": {
        return "#F2BB25";
      }
      case "In Progress": 
      case "Cancelled O2up": 
      case "Finished O2up": 
      {
        return "#00B162";
      }
      case "Finished": {
        return "#152235";
      }
      case "Cancelled": {
        return "#E54949";
      }
      default: {
        return;
      }
    }
  }

  isO2Up(status): boolean{
    if (["Cancelled O2up","Finished O2up"].includes(status)){
      return true;
    }
    return false;
  }

  getLabel(status): string | VueI18n.TranslateResult {
    switch (status) {
      case "In Request": {
        return this.$t("text.inRequest");
      }
      case "In Progress": 
      case "Cancelled O2up": 
      case "Finished O2up": 
      {
        return this.$t("text.inProgress");
      }
      case "Finished": {
        return this.$t("text.finished");
      }
      case "Cancelled": {
        return this.$t("text.cancelled");
      }
      default: {
        return;
      }
    }
  }

  getActionByStatus(status: string, autoStopDate?:string, isTicked?: boolean): Array<IAction> {
    switch (status) {
      case "In Request": {
        return [
          this.START_ACTION,
          this.VIEW_ACTION,
          this.EDIT_ACTION,
          this.DELETE_ACTION,
        ];
      }
      case "In Progress": {
        const temp =  [this.VIEW_ACTION, this.EDIT_ACTION, this.STOP_ACTION];
        // if (!autoStopDate) {
        //   this.lodash.remove(temp, val => val.action ===  ACTION.EDIT);
        // }
        return temp;
      }
      case "Finished": {
        const actions = [
          this.VIEW_ACTION,
          this.VIEW_GRAPH_ACTION,
          this.EDIT_ACTION,
        ];
        if (isTicked !== false) {
          actions.push(this.VIEWCERTIFICATE_ACTION);
        }
        return actions;
      }
      case "Finished O2up": 
      case "Cancelled O2up": 
      {
        return [this.VIEW_ACTION];
      }
      case "Cancelled": {
        const actions = [
          this.VIEW_ACTION,
          this.CONTINUE_ACTION,
          this.VIEW_GRAPH_ACTION,
          this.EDIT_ACTION,
        ];
        
        // Only show VIEWCERTIFICATE_ACTION if isTicked is not false
        // (allow if isTicked is true, undefined, or null)
        if (isTicked !== false) {
          actions.push(this.VIEWCERTIFICATE_ACTION);
        }
        
        return actions;
      }
      default: {
        return [];
      }
    }
  }

  headerThisPage = [];
  async doSearch(loadingOn: boolean = true): Promise<void> {
    try {
      if (loadingOn) this.$util.showLoading();
      this.loading = true;
      await this.handleFilterTreatmentRequest();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.loading = false;
      this.$util.hideLoading();
    }
  }

  setPointsIsActive = [];
  async handleGetMasterList() {
    let res;
    try {
      res = await new TreatmentMasterListsApi().getTreatments();
    } catch (error) {
      this.$util.showError(error);
      throw new Error("getTreatments Failed");
    }
    const isActive = (val): boolean => val.status === "Active";
    const typeTechnique = "technique";
    const typeSetpoint = "setpoint";

    const allOption = {
      code: 0,
      defaultSetPoint: true,
      id: 0,
      status: "Active",
      treatmentName: this.$t("text.all"),
    };
    this.techniqueOptions = res.data.data.filter(
      (val) => val.treatmentType === typeTechnique && isActive(val)
    );
    this.setPointOptions = res.data.data.filter(
      (val) => val.treatmentType === typeSetpoint && isActive(val)
    );
    this.techniqueOptions.unshift(allOption);
  }

  async handleFilterTreatmentRequest() {
    const getValueOrUndefined = (value) => {
      return value ? value : undefined;
    };
    const startDate = this.searchParam.dateFrom
      ? moment(this.searchParam.dateFrom, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const endDate = this.searchParam.dateTo
      ? moment(this.searchParam.dateTo, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;

    const body = {
      keyword: getValueOrUndefined(this.searchParam.keyword),
      technique: getValueOrUndefined(this.searchParam.technique),
      status: getValueOrUndefined(this.searchParam.status),
      startDate: startDate,
      endDate: endDate,
      limit: this.pagingOption.itemsPerPage,
      page: this.pagingOption.page,
      orderBy: getValueOrUndefined(this.pagingOption.sortBy[0]),
      orderDesc: getValueOrUndefined(this.pagingOption.sortDesc[0]),
    } as TreatmentRequestsApiGetTreatmentRequestsByKeywordRequest;

    try {
      const res =
        await new TreatmentRequestsApi().getTreatmentRequestsByKeyword(body);
      this.totalRecord = res.data.count;
      this.items = res.data.data.map((treatmentReq) => this.prepareTreatmentRequest(treatmentReq)).filter(treatmentReq => !!treatmentReq);
    } catch (error) {
      this.$util.showError(error);
      throw new Error("getTreatmentDatatbasesSearch Failed");
    }
  }

  prepareTreatmentRequest(treatmentReq) {
    try {
      const setPointHaveName = treatmentReq.setPoint.map(setPoint => 
      {
       const mapping = this.setPointOptions.find(setPointOpt => setPointOpt.id === setPoint.id);
        const name = ( mapping && mapping.treatmentName) ? mapping.treatmentName :"";
        return {...setPoint, name};
      });
      const setPointCondition = (setPointHaveName as any)
      .filter(setPoint => ["O2 level", "Product Temp (° C)"].includes(setPoint.name))
      .map(setPoint => `${setPoint.name}: ${setPoint.value}`);
      const condition = [...setPointCondition, `${treatmentReq.treatmentTime} ${treatmentReq.treatmentFormat}`].join(", ");
      const result = {
        ...treatmentReq,
        condition: condition,
        insects: treatmentReq.insects.map((insect) => insect["treatmentName"]).join("; "),
        treatmentTime: `${treatmentReq.treatmentTime} ${treatmentReq.treatmentFormat} `
      };
      for (let i = 0; i < 4; i++) {
        const sp = setPointHaveName[i];
        result[`setPointName${i + 1}`] = sp ? sp.name : "";
        result[`setPointValue${i + 1}`] = sp ? sp.value : "";
      }
      return result;
    } catch (error) {
      return undefined;
    }
  }

  selectedTreatment = null;
  selectedAction: ACTION = null;
  onSelectedTreatment({ item, action }): void {
    this.selectedTreatment = { ...item };
    this.selectedAction = action;
    switch (action) {
      case ACTION.VIEW: {
        this.onViewTreatment();
        break;
      }
      case ACTION.VIEWCERTIFICATE: {
        const routeData = this.$router.resolve({name: 'certificate-treatment', params: { id: item._id },});
        window.open(routeData.href, '_blank');
        break;
      }
      case ACTION.GRAPH: {
        const routeData = this.$router.resolve({name: 'certificate-graph', params: { id: item._id },});
        window.open(routeData.href, '_blank');
        break;
      }
      case ACTION.EDIT: {
        this.onEditTreatment();
        break;
      }
      case ACTION.DELETE: {
        this.onDeleteTreatment();
        break;
      }
      case ACTION.START: {
        this.onStartTreatmentRequest();
        break;
      }
      case ACTION.CONTINUE: {
        this.onContinueTreatmentRequest();
        break;
      }
      case ACTION.STOP: {
        this.onStopTreatmentRequest();
        break;
      }
      // case ACTION.FINISH: {
      //   this.onFinishTreatmentRequest();
      //   break;
      // }
      default: {
        console.error(action);
        break;
      }
    }
  }

  onViewTreatment() {
    return this.$router.push({
      name: "view-treatment-request",
      params: { id: this.selectedTreatment._id },
    });
  }

  onEditTreatment() {
    return this.$router.push({
      name: "edit-treatment-request",
      params: { id: this.selectedTreatment._id },
    });
  }

  onDeleteTreatment() {
    this.showConfirmDialog = true;
    this.confirmContent = this.$t("dialog.delete.treatmentRequest");
  }

  async onOkConfirmDialog() {
    if (this.selectedAction === ACTION.DELETE) {
      await this.doDelete();
      return;
    }
    if (this.selectedAction === ACTION.START) {
      await this.doStartTreatmentRequest();
      return;
    }
    if (this.selectedAction === ACTION.STOP) {
      await this.doStopTreatmentRequest();
      return;
    }
  }

  onStartTreatmentRequest() {
    this.showConfirmDialog = true;
    this.confirmContent = this.$t("dialog.start.treatmentRequest");
  }

  async doStartTreatmentRequest() {
    this.$util.showLoading();
    try {
      await new TreatmentRequestsApi().startTreatmentRequest({
        id: this.selectedTreatment._id,
      });
      this.showConfirmDialog = false;
      this.doSearch();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onContinueTreatmentRequest() {
    this.isShowContinueTreatmentDialog = true;
  }

  async continuedTreatmentRequest() {
    this.isShowContinueTreatmentDialog = false;
    this.doSearch();
  }

  onStopTreatmentRequest() {
    this.isShowStopTreatmentDialog = true;
  }

  async stoppedTreatmentRequest() {
    this.isShowStopTreatmentDialog = false;
    this.doSearch();
  }


  // onFinishTreatmentRequest() {
  //   this.isShowFinishTreatmentDialog = true;
  // }
  //
  // async onFinishedTreatmentRequest() {
  //   this.isShowFinishTreatmentDialog = false;
  //   await this.doSearch();
  // }

  async doStopTreatmentRequest() {
    // this.$util.showLoading();
    // try {
    //   await new TreatmentRequestsApi().stopTreatmentRequest({
    //     id: this.selectedTreatment._id,
    //     putStopTreatmentRequestRequest: {
    //       isAddWeight: false,
    //       isManual: true,
    //       autoStopDate: "",
    //     },
    //   });
    //   this.showConfirmDialog = false;
    //   this.doSearch();
    // } catch (error) {
    //   this.$util.showError(error);
    // } finally {
    //   this.$util.hideLoading();
    // }
  }

  async doDelete() {
    this.$util.showLoading();
    try {
      await new TreatmentRequestsApi().deleteTreatmentRequest({
        id: this.selectedTreatment._id,
      });
      this.showConfirmDialog = false;
      this.doSearch();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  get exportClick() {
    return this.$store.getters.export;
  }

  @Watch("exportClick")
  onexportClick() {
    this.doExport();
  }
  getSetPoinName(id){
    const mapping =  this.setPointOptions.find(setPointOpt => setPointOpt.id === id);
    return mapping ? mapping.treatmentName : "";
  }
  async doExport() {
    const getValueOrUndefined = (value) => {
      return value ? value : undefined;
    };
    const startDate = this.searchParam.dateFrom
      ? moment(this.searchParam.dateFrom, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const endDate = this.searchParam.dateTo
      ? moment(this.searchParam.dateTo, "YYYY-MM-DD HH:mm")
          .utc()
          .format("YYYY-MM-DD HH:mm")
      : undefined;
    const body = {
      keyword: getValueOrUndefined(this.searchParam.keyword),
      technique: getValueOrUndefined(this.searchParam.technique),
      status: getValueOrUndefined(this.searchParam.status),
      startDate: startDate,
      endDate: endDate,
    } as TreatmentRequestsApiExportTreatmentRequestsByKeywordRequest;
    try {
      this.$util.showLoading();
      const res =
        await new TreatmentRequestsApi().exportTreatmentRequestsByKeyword(body);
      this.dataExport = res.data.data.map((treatmentReq) => {
        const setPointHaveName = treatmentReq.setPoint.map(setPoint => ({
          ...setPoint,
          name: this.getSetPoinName(setPoint.id)
        }));
        const setPointCondition = (setPointHaveName as any)
        .filter(setPoint => ["O2 level", "Product Temp (° C)"].includes(setPoint.name))
        .map(setPoint => `${setPoint.name}: ${setPoint.value}`);
        const condition = [...setPointCondition, `${treatmentReq.treatmentTime} ${treatmentReq.treatmentFormat}`].join(", ");
        return {
          ...treatmentReq,
          startDate:treatmentReq.startDate? moment(treatmentReq.startDate).format("D MMM, YYYY HH:mm"):'',
          endDate: treatmentReq.endDate? moment(treatmentReq.endDate).format("D MMM, YYYY HH:mm") :'',
          setPoint: treatmentReq.setPoint
            .filter((setPoint) => !isEmpty(setPoint.value))
            .map((setPoint) => {
              const setPointName =  this.getSetPoinName(setPoint.id);
              return setPointName;
            })
            .join("; "),
          insects: treatmentReq.insects
            .map((insect) => insect["treatmentName"])
            .join("; "),
          treatmentTime: `${treatmentReq.treatmentTime} ${
            this.formatTimeOptions.find(
              (option) =>
                option.value === treatmentReq.treatmentFormat.toUpperCase()
            ).text || treatmentReq.treatmentFormat
          }`,
          treatmentType: `${
            this.treatmentTypeOptions.find(
              (option) =>
                option.value.toUpperCase() ===
                treatmentReq.treatmentType.toUpperCase()
            ).text || treatmentReq.treatmentType
          }`,
          condition: condition,
          startTemperature: treatmentReq.startTemperature,
          numberOfPallets: treatmentReq.isPallet? treatmentReq.totalWeight : "",
          totalWeight: !treatmentReq.isPallet? treatmentReq.totalWeight : "",
          reachingO2Level: treatmentReq.reachingO2Level? moment(treatmentReq.reachingO2Level).format("D MMM, YYYY HH:mm") :'',
          reachingProductTemp:treatmentReq.reachingProductTemp? moment(treatmentReq.reachingProductTemp).format("D MMM, YYYY HH:mm") :'',
          expectedEndDate: treatmentReq.expectedEndDate? moment(treatmentReq.expectedEndDate).format("D MMM, YYYY HH:mm"):'',
          setPointName1: setPointHaveName[0] ? setPointHaveName[0].name : "",
          setPointValue1: setPointHaveName[0] ? setPointHaveName[0].value : "",
          setPointName2: setPointHaveName[1] ? setPointHaveName[1].name : "",
          setPointValue2: setPointHaveName[1] ? setPointHaveName[1].value : "",
          setPointName3: setPointHaveName[2] ? setPointHaveName[2].name : "",
          setPointValue3: setPointHaveName[2] ? setPointHaveName[2].value : "",
          setPointName4: setPointHaveName[3] ? setPointHaveName[3].name : "",
          setPointValue4: setPointHaveName[3] ? setPointHaveName[3].value : "",
        };
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      const data = this.lodash.reverse(this.dataExport);
      const exportExcel = new VueExcelEco2(
        "ECO2 - Export Treatment Request",
        "xlsx",
        "ECO2 Web",
        data,
        this.columnsExport
      ).exportExcel();
      this.$util.hideLoading();
    }
  }

  onViewCertificateList(treatmentRequestNumber: string, hasShipmentCertificate: boolean) {
    if (!hasShipmentCertificate) return;
    return this.$router.push({
      name: "shipment",
      query: { keyword: treatmentRequestNumber },
    });
  }
}
